// Generated by createPages before Gatsby compiles browser and SSR bundles.
// One shared module replaces the identical route map in every page-data file.
const sharedPagePaths: Record<
    string,
    string
> = require('../../.cache/shared-page-paths.json');
export default sharedPagePaths;
